import { GAME_SHORT_NAMES, GAMES_COMING_SOON } from "@/app/constants.mjs";
import type { GameSymbol } from "@/app/games.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import SymbolMap from "@/util/symbol-map.mjs";

// The categorization by game routes is used for showing the correct context
// in the app, most notably the app navigation.
const comingSoonRoutes = new SymbolMap({
  ...GAMES_COMING_SOON.reduce((obj, gameSymbol) => {
    obj[gameSymbol] = [
      {
        path: `/${GAME_SHORT_NAMES[gameSymbol]}`,
        component: "marketing/GameComingSoon.tsx",
      },
    ];
    return obj;
  }, {}),
} as Record<GameSymbol, BaseRoute[]>);

export default comingSoonRoutes;
